import React__default from 'react';
import modules_2f9e3bf6 from './LoadingBar.module.css.mjs';

/**
 * A fake loading bar that goes to 100% over 10s
 */ const LoadingBar = ({ isLoading })=>/*#__PURE__*/ React__default.createElement("div", {
        role: "progressbar",
        className: modules_2f9e3bf6.container
    }, isLoading && /*#__PURE__*/ React__default.createElement("div", {
        className: modules_2f9e3bf6.progress
    }));

export { LoadingBar as default };
//# sourceMappingURL=LoadingBar.mjs.map
